import { ref } from "@vue/composition-api";
import axios from "axios";
import LoginViewModel from "@/models/LoginViewModel";
import { configureRouter } from "@/router";
export default () => {
    const returnUrl = ref<string>();

    const serverLogin = async (model: LoginViewModel) => {
        const routerObj = await configureRouter();

        axios.post("/api/Account/login", model).then((response) => {
            const url = routerObj.currentRoute.query.ReturnUrl.toString();
            routerObj.push({ path: url });
        });
    };
    return {
        returnUrl,
        serverLogin,
    };
};
